/* IPO & Earnings Page — Two-tab dashboard with live data
   Uses Phase 4.1 components, fixes tab switching bug */

import { renderIPOUpcoming } from '../components/IPOUpcoming';
import { renderIPOLiveSubscription } from '../components/IPOLiveSubscription';
import { renderIPOListed } from '../components/IPOListed';
import { renderEarningsCalendar } from '../components/EarningsCalendar';
import { renderEarningsResults } from '../components/EarningsResults';

function renderIPOTab(container: HTMLElement): void {
  container.innerHTML = `
    <div id="ipo-upcoming"></div>
    <div id="ipo-live-sub" style="margin-top: var(--space-6);"></div>
    <div id="ipo-listed" style="margin-top: var(--space-6);"></div>
  `;
  const upEl = document.getElementById('ipo-upcoming');
  if (upEl) renderIPOUpcoming(upEl);

  const liveEl = document.getElementById('ipo-live-sub');
  if (liveEl) renderIPOLiveSubscription(liveEl);

  const listedEl = document.getElementById('ipo-listed');
  if (listedEl) renderIPOListed(listedEl);
}

function renderEarningsTab(container: HTMLElement): void {
  container.innerHTML = `
    <div id="earnings-calendar"></div>
    <div id="earnings-results" style="margin-top: var(--space-6);"></div>
  `;
  const calEl = document.getElementById('earnings-calendar');
  if (calEl) renderEarningsCalendar(calEl);

  const resEl = document.getElementById('earnings-results');
  if (resEl) renderEarningsResults(resEl);
}

export function renderIPOEarnings(): string {
  return `
    <div style="margin-bottom: var(--space-6);">
      <div class="period-toggle" id="ipo-tabs">
        <button class="period-toggle__btn period-toggle__btn--active" data-ipo-tab="ipo">💼 IPO Dashboard</button>
        <button class="period-toggle__btn" data-ipo-tab="earnings">💰 Earnings Tracker</button>
      </div>
    </div>
    <div id="ipo-content"></div>
  `;
}

export function initIPOEarnings(): void {
  const contentEl = document.getElementById('ipo-content');
  const tabsEl = document.getElementById('ipo-tabs');
  if (!contentEl || !tabsEl) return;

  // Load IPO tab by default
  renderIPOTab(contentEl);

  // Tab switching
  tabsEl.querySelectorAll('[data-ipo-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = (btn as HTMLElement).dataset.ipoTab;

      // Update active state
      tabsEl.querySelectorAll('.period-toggle__btn').forEach(b => b.classList.remove('period-toggle__btn--active'));
      btn.classList.add('period-toggle__btn--active');

      // Render tab content
      if (tabId === 'ipo') renderIPOTab(contentEl);
      else renderEarningsTab(contentEl);
    });
  });
}
